module.exports = __webpack_public_path__ + "img/netProfitBlue.73d5f03d.png";